















































































import Vue from 'vue'
import axios from 'axios'
import Component from 'vue-class-component'
import EditDialog from '../components/EditDialog.vue'

@Component({
  components: {
    EditDialog
  }
})
export default class PracticumView extends Vue {
  data?: any = null

  dialog = false

  get adminView() {
    return this.$store.state.auth.isAdmin
  }

  get breadcrumbs() {
    return [
      { text: 'Practicums' },
      { text: this.data.name, url: `/practicums/${this.data.id}`}
    ]
  }

  get TeflCourseId() {
    return process.env.VUE_APP_COURSE_ID
  }

  get isEnrolled(): boolean {
    return !!this.data && !!this.data.userProgress
  }

  get notPaid(): boolean {
    if (!this.data.userProgress) {
      return false
    }

    return !this.data.userProgress.paid
  }

  get isCertified(): boolean {
    return !!this.data && !!this.data.userProgress && !!this.data.userProgress.certified
  }

  get practicumCompleted() {
    return this.practicumStatus === 'completed' && !this.isCertified
  }

  get practicumStatus() {
    if (!this.data) return null

    if (!this.data.userProgress) return null

    return this.data.userProgress.status
  }

  async mounted() {
    this.getData()
  }

  async getData() {
    this.data = (await axios.get(`practicums/${this.$route.params.practicumId}`)).data
  }

  async enrollUser() {
    try {
      await axios.post(`practicums/${this.$route.params.practicumId}/enroll`)
      this.$router.push(`/practicums/${this.$route.params.practicumId}/students/${this.$store.state.auth.userId}/checkout`)
    } catch (error) {
      this.$store.dispatch('showError', 'Unable to register for practicum')
    }
  }

  async submit(data: any) {
    await axios.put(`practicums/${this.$route.params.practicumId}`, data).then((response) => {
      this.data = response.data
      this.dialog = false
      this.$store.dispatch('showSuccess', 'Practicum updated successfully')
    }).catch((err) => {
      this.$store.dispatch('showError', 'Error updating practicum details')
    })
  }

  openDialog() {
    this.dialog = true
  }
}
